import { Box, Tab, Tabs } from '@mui/material';
// import BackButton from 'components/ui/BackButton';
import FormTextField from 'components/ui/form/FormTextField';
import { useFormik } from 'formik';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useFormSubmit from 'hooks/useFormSubmit';
import useTopPanel from 'hooks/useTopPanel';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';
import CRMCardLeadHistory from './CRMCardLeadHistory';
import { InfoSection, SettingsSection, StatisticsSection } from './edit-items';
import usePermission from 'hooks/usePermission';
import CrmVidgets from './CrmVitged';

const validationSchema = yup.object({
  name: yup.string().min(3).required(),
  crm_block_id: yup.string().nullable(),
  crm_block_item_id: yup.string(),
  user_id: yup.string().nullable(),
  budget: yup.number().nullable(),
  // operator_id: yup.string().nullable(),
  // object_id: yup.string().nullable(),
  // source_id: yup.string().nullable(),
  // reject_type_id: yup.string().nullable(),
  contacts: yup
    .array()
    .of(
      yup.object({
        id: yup.string().optional(),
        name: yup.string().min(1).nullable(),
        // region_id: yup.number().nullable(),
        phones: yup
          .array()
          .of(
            yup.object({
              id: yup.string().optional(),
              phone: yup.string().length(13).nullable(),
            })
          )
          .min(1),
      })
    )
    .min(1),
});

const CRMCardAddEdit = () => {
  const { setComponent } = useTopPanel();
  const { hasPermission } = usePermission();
  const { id } = useParams();
  const { t } = useTranslation();
  const axiosPrivate = useAxiosPrivate();
  const { submit, isSubmitting } = useFormSubmit();
  const [hasError, setHasError] = useState(false);
  const [tabIndex, setTabIndex] = useState(1);
  const [refetchGetField, setRefetchGetField] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: '',
      crm_block_id: '',
      crm_block_item_id: '',
      user_id: '',
      budget: '',
      // operator_id: '',
      // object_id: '',
      // source_id: '',
      // reject_type_id: '',
      fields: [],
      contacts: [
        {
          name: '',
          // region_id: '',
          phones: [
            {
              phone: '',
            },
          ],
        },
      ],
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const fields = values?.fields?.filter(({ value }) => value);
      const body = { ...values, fields };
      if (id) {
        submit(
          { type: 'put', contentType: 'simple' },
          body,
          `/crm/crm-lead/${id}`,
          body.name,
          null,
          true,
          refetch
        );
      } else
        submit(
          { type: 'post', contentType: 'simple' },
          body,
          '/crm/crm-lead',
          body.name,
          null,
          true
        );

      setRefetchGetField(true);
    },
  });

  const { isLoading, isFetching, refetch, data } = useQuery({
    queryKey: ['/crm/crm-lead/edit/{id}', id],
    queryFn: async function () {
      const response = await axiosPrivate.get(`/crm/crm-lead/edit/${id}`);
      return response.data.data;
    },
    onSuccess: (res) => {
      const data = res?.lead;
      if (data) {
        formik.setValues({
          name: data?.name || '',
          crm_block_id: data?.crm_block_id || '',
          crm_block_item_id: data?.crm_block_item_id || '',
          user_id: data?.user_id || '',
          budget: data?.budget ?? '',
          fields: [],
          contacts:
            data?.contacts && data?.contacts?.length > 0
              ? data?.contacts
              : [
                  {
                    name: '',
                    // region_id: '',
                    phones: [
                      {
                        phone: '',
                      },
                    ],
                  },
                ],
        });
        setRefetchGetField(true);
      }
    },
    enabled: !hasError && !!id,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  const handleAddPhone = (contactInd) => {
    formik.setFieldValue(
      `contacts.${contactInd}.phones`,
      [
        ...JSON.parse(
          JSON.stringify(formik.values.contacts[contactInd].phones)
        ),
        {
          phone: '',
        },
      ],
      true
    );
  };

  const handleAddContact = () => {
    formik.setFieldValue(
      'contacts',
      [
        ...JSON.parse(JSON.stringify(formik.values.contacts)),
        {
          name: '',
          region_id: '',
          phones: [
            {
              phone: '',
            },
          ],
        },
      ],
      true
    );
  };

  const handleRemoveContact = (contactInd) => {
    let newContacts = JSON.parse(JSON.stringify(formik.values.contacts)).filter(
      (item, index) => index != contactInd
    );
    formik.setFieldValue('contacts', [...newContacts], true);
  };
  const handleChangeTab = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    setComponent(
      <div className='crm-card-add-edit-top-wrapper'>
        {/* <BackButton /> */}
        <div className='ml-4 mb-6'>
          <FormTextField
            delay={0}
            duration={0}
            label='Nomi'
            fieldName='name'
            formik={formik}
            variant='standard'
          />
        </div>
      </div>
    );
  }, [formik.values.name, formik.errors.name, formik.touched.name]);

  return (
    <div className='component-add-edit-wrapper crm-card-add-edit-wrapper'>
      <div className='component-add-edit-body crm-card-add-edit-body'>
        {/* {isLoading || isFetching ? (
          <div className='circular-progress-box py-5'>
            <CircularProgress size={35} />
          </div>
        ) : ( */}
        <div className='crm-card-add-edit-body-wrapper'>
          <div className='!w-[30%] border-r'>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
              }}
            >
              <Tabs
                value={tabIndex}
                onChange={handleChangeTab}
                sx={{
                  minHeight: 35,
                  height: 35,
                }}
              >
                <Tab
                  label={t('crm.block.info.title')}
                  value={1}
                  sx={{
                    fontSize: 12,
                    minHeight: 35,
                    height: 35,
                  }}
                />
                <Tab
                  label={t('crm.block.statistics.title')}
                  value={2}
                  sx={{
                    fontSize: 12,
                    minHeight: 35,
                    height: 35,
                  }}
                />
                {hasPermission('SETTINGS') && (
                  <Tab
                    label={t('crm.block.settings.title')}
                    value={3}
                    sx={{
                      fontSize: 12,
                      minHeight: 35,
                      height: 35,
                    }}
                  />
                )}
              </Tabs>
            </Box>

            {tabIndex == 1 && (
              <InfoSection
                formik={formik}
                handleAddPhone={handleAddPhone}
                handleRemoveContact={handleRemoveContact}
                handleAddContact={handleAddContact}
                isSubmitting={isSubmitting}
                refetch={refetchGetField}
                setRefetch={setRefetchGetField}
                isLoadingLeadInfo={isLoading || isFetching}
              />
            )}
            {tabIndex == 2 && (
              <StatisticsSection createdAt={data?.lead?.created_at} />
            )}
            {hasPermission('SETTINGS') && tabIndex == 3 && (
              <SettingsSection formik={formik} />
            )}
          </div>
          <div className='lead-history-body-wrapper bg-[#f0f2f5]'>
            <CRMCardLeadHistory isUserNew={!id} />
          </div>
          <div className='h-full min-w-[350px] border-l'>
            <CrmVidgets />
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
};
export default CRMCardAddEdit;
